import { render } from "./DataSizeHistory.vue?vue&type=template&id=67c221fc&scoped=true&ts=true"
import script from "./DataSizeHistory.vue?vue&type=script&lang=ts"
export * from "./DataSizeHistory.vue?vue&type=script&lang=ts"

import "./DataSizeHistory.vue?vue&type=style&index=0&id=67c221fc&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c221fc"]])

export default __exports__